import { Allocation, VariationType, Variations } from '../components';

export const getExperimentGroupById = (allocations: Allocation[] | null, experimentId: string) =>
  (allocations || []).find((allocation) => allocation.experimentIdentifier === experimentId)?.group;

export const isTargetVariation = (variation?: VariationType) => variation === Variations.FLAG_TARGET;

export const isTargetAVariation = (variation?: VariationType) => variation === Variations.FLAG_TARGET_A;

export const isTargetBVariation = (variation?: VariationType) => variation === Variations.FLAG_TARGET_B;

export const isTargetCVariation = (variation?: VariationType) => variation === Variations.FLAG_TARGET_C;

export const isControlVariation = (variation?: VariationType) => variation === Variations.FLAG_CONTROL;

export const isExcludedVariation = (variation?: VariationType) => variation === Variations.FLAG_EXCLUDED;
